import { ReactNode, CSSProperties } from "react";
import { cn } from "../lib/utils";

export function PolicyTextStyle({
  children,
  className,
  style,
}: {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <div className={cn("policy-text-style", className)} style={style}>
      {children}
    </div>
  );
}
